/**
 * Created by Administrador on 07/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('profileUser', {
                url: '/profileUser/profileUser',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main': {
                        templateUrl: 'app/profileUser/profileUser/profileUser.html',
                        controller: 'profileUserCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['profileUser']);
                            }],
                            profileUser: ['profileUserService', function(profileUserService){
                                return profileUserService.getProfile();
                            }]
                        }
                    }
                }
            });
    }
})();
